"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("babel-polyfill");
var vue_1 = require("vue");
var AppContactEmbedded_vue_1 = require("./AppContactEmbedded.vue");
var store_1 = require("./store");
vue_1.default.config.productionTip = false;
new vue_1.default({
    store: store_1.default,
    render: function (h) { return h(AppContactEmbedded_vue_1.default); }
}).$mount('#app');
